/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./types";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getDashboardStats = /* GraphQL */ `query GetDashboardStats(
  $stats: DashboardStatsInput
  $tenantIDs: [String]
  $userId: String
) {
  getDashboardStats(stats: $stats, tenantIDs: $tenantIDs, userId: $userId) {
    status
    data {
      totalAssets
      assetsPerLocation {
        label
        itemCount
        value
        percentage
        filterByValue
        __typename
      }
      assetsPerCondition {
        label
        itemCount
        value
        percentage
        filterByValue
        __typename
      }
      assetsPerType {
        label
        itemCount
        value
        percentage
        filterByValue
        __typename
      }
      assetsPerExpenses {
        label
        itemCount
        value
        percentage
        filterByValue
        __typename
      }
      totalFindings
      findingsPerType {
        label
        itemCount
        value
        percentage
        filterByValue
        __typename
      }
      findingsPerPriority {
        label
        itemCount
        value
        percentage
        filterByValue
        __typename
      }
      findingsPerAssetModel {
        label
        itemCount
        value
        percentage
        filterByValue
        __typename
      }
      all {
        totalWorkOrders
        workOrdersPerCategory {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersPerPriority {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersPerState {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersPerDueData {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersPerDueDate {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersSLAData {
          key
          warningValue
          thresholdValue
          statsPoints {
            label
            itemCount
            value
            percentage
            filterByValue
            __typename
          }
          __typename
        }
        __typename
      }
      user {
        totalWorkOrders
        workOrdersPerCategory {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersPerPriority {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersPerState {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersPerDueData {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersPerDueDate {
          label
          itemCount
          value
          percentage
          filterByValue
          __typename
        }
        workOrdersSLAData {
          key
          warningValue
          thresholdValue
          statsPoints {
            label
            itemCount
            value
            percentage
            filterByValue
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardStatsQueryVariables,
  APITypes.GetDashboardStatsQuery
>;
export const getCurrentUser = /* GraphQL */ `query GetCurrentUser {
  getCurrentUser {
    data {
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        cognitoId
        __typename
      }
      tenants {
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        role
        __typename
      }
      tenantIDs
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCurrentUserQueryVariables,
  APITypes.GetCurrentUserQuery
>;
export const getAsset = /* GraphQL */ `query GetAsset($id: String!) {
  getAsset(id: $id) {
    data {
      id
      number
      displayNumber
      userId
      assetTag
      description
      makeId
      modelId
      state
      usefulLife
      acquisitionCostValue
      lastMaintenanceDate
      nextScheduledMaintenanceDate
      assignedToId
      assetTypeId
      condition
      maintenanceCostValue
      currentBookValue
      installDate
      decommissionDate
      locationId
      image
      purchaseOrderId
      utilizationData
      reasonForDecommission
      serialNumber
      thirdPartyId
      source
      totalCostOfOwnershipValue
      repairCostValue
      warrantyExpiration
      downTime
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        inUseStatus
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      woCount
      findingsCount
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetRisk
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      isParent
      thirdPartyParentId
      thirdPartyHierarchyPath
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<APITypes.GetAssetQueryVariables, APITypes.GetAssetQuery>;
export const getAssetList = /* GraphQL */ `query GetAssetList($params: QueryListParams) {
  getAssetList(params: $params) {
    data {
      id
      number
      displayNumber
      userId
      assetTag
      description
      makeId
      modelId
      state
      usefulLife
      acquisitionCostValue
      lastMaintenanceDate
      nextScheduledMaintenanceDate
      assignedToId
      assetTypeId
      condition
      maintenanceCostValue
      currentBookValue
      installDate
      decommissionDate
      locationId
      image
      purchaseOrderId
      utilizationData
      reasonForDecommission
      serialNumber
      thirdPartyId
      source
      totalCostOfOwnershipValue
      repairCostValue
      warrantyExpiration
      downTime
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        inUseStatus
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      woCount
      findingsCount
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetRisk
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      isParent
      thirdPartyParentId
      thirdPartyHierarchyPath
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssetListQueryVariables,
  APITypes.GetAssetListQuery
>;
export const getAssetPropsCounts = /* GraphQL */ `query GetAssetPropsCounts {
  getAssetPropsCounts {
    data {
      assets
      types
      manufacturers
      models
      locations
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssetPropsCountsQueryVariables,
  APITypes.GetAssetPropsCountsQuery
>;
export const getAssetRelatedCounts = /* GraphQL */ `query GetAssetRelatedCounts($assetId: String!) {
  getAssetRelatedCounts(assetId: $assetId) {
    data {
      workOrders
      findings
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssetRelatedCountsQueryVariables,
  APITypes.GetAssetRelatedCountsQuery
>;
export const getWorkOrder = /* GraphQL */ `query GetWorkOrder($id: String!) {
  getWorkOrder(id: $id) {
    data {
      id
      displayNumber
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      userId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      locationId
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      assetLocation {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      dueDate
      startDate
      endDate
      duration
      plannedStartDate
      plannedEndDate
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assignmentGroupId
      assignedToId
      assignedTo {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      businessDownTime
      downTimeStart
      downTimeEnd
      category
      checklist
      closedNotes
      closedAt
      closedById
      closedBy {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      notes
      title
      description
      estimatedCostValue
      actualCostValue
      estimatedEffort
      actualEffort
      expectedOperationalDate
      impact
      priority
      dependsOnWorkOrderId
      dependsOnWorkOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        dependsOnWorkOrder {
          id
          displayNumber
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          number
          userId
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          locationId
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          assetLocation {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          dueDate
          startDate
          endDate
          duration
          plannedStartDate
          plannedEndDate
          assetId
          asset {
            id
            number
            displayNumber
            userId
            assetTag
            description
            makeId
            modelId
            state
            usefulLife
            acquisitionCostValue
            lastMaintenanceDate
            nextScheduledMaintenanceDate
            assignedToId
            assetTypeId
            condition
            maintenanceCostValue
            currentBookValue
            installDate
            decommissionDate
            locationId
            image
            purchaseOrderId
            utilizationData
            reasonForDecommission
            serialNumber
            thirdPartyId
            source
            totalCostOfOwnershipValue
            repairCostValue
            warrantyExpiration
            downTime
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            woCount
            findingsCount
            assetRisk
            isParent
            thirdPartyParentId
            thirdPartyHierarchyPath
            __typename
          }
          assignmentGroupId
          assignedToId
          assignedTo {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          businessDownTime
          downTimeStart
          downTimeEnd
          category
          checklist
          closedNotes
          closedAt
          closedById
          closedBy {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          notes
          title
          description
          estimatedCostValue
          actualCostValue
          estimatedEffort
          actualEffort
          expectedOperationalDate
          impact
          priority
          dependsOnWorkOrderId
          dependsOnWorkOrder {
            id
            displayNumber
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            number
            userId
            locationId
            dueDate
            startDate
            endDate
            duration
            plannedStartDate
            plannedEndDate
            assetId
            assignmentGroupId
            assignedToId
            businessDownTime
            downTimeStart
            downTimeEnd
            category
            checklist
            closedNotes
            closedAt
            closedById
            notes
            title
            description
            estimatedCostValue
            actualCostValue
            estimatedEffort
            actualEffort
            expectedOperationalDate
            impact
            priority
            dependsOnWorkOrderId
            state
            type
            templateId
            isArchived
            findingId
            seenByAssignee
            assignmentDateTime
            seenDateTime
            startOfWorkDateTime
            endOfWorkDateTime
            __typename
          }
          state
          type
          templateId
          isArchived
          findingId
          seenByAssignee
          assignmentDateTime
          seenDateTime
          startOfWorkDateTime
          endOfWorkDateTime
          assetModel {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          __typename
        }
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      state
      type
      templateId
      isArchived
      findingId
      seenByAssignee
      assignmentDateTime
      seenDateTime
      startOfWorkDateTime
      endOfWorkDateTime
      assetModel {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkOrderQueryVariables,
  APITypes.GetWorkOrderQuery
>;
export const getWorkOrderList = /* GraphQL */ `query GetWorkOrderList($params: QueryListParams) {
  getWorkOrderList(params: $params) {
    data {
      id
      displayNumber
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      userId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      locationId
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      assetLocation {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      dueDate
      startDate
      endDate
      duration
      plannedStartDate
      plannedEndDate
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assignmentGroupId
      assignedToId
      assignedTo {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      businessDownTime
      downTimeStart
      downTimeEnd
      category
      checklist
      closedNotes
      closedAt
      closedById
      closedBy {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      notes
      title
      description
      estimatedCostValue
      actualCostValue
      estimatedEffort
      actualEffort
      expectedOperationalDate
      impact
      priority
      dependsOnWorkOrderId
      dependsOnWorkOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        dependsOnWorkOrder {
          id
          displayNumber
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          number
          userId
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          locationId
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          assetLocation {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          dueDate
          startDate
          endDate
          duration
          plannedStartDate
          plannedEndDate
          assetId
          asset {
            id
            number
            displayNumber
            userId
            assetTag
            description
            makeId
            modelId
            state
            usefulLife
            acquisitionCostValue
            lastMaintenanceDate
            nextScheduledMaintenanceDate
            assignedToId
            assetTypeId
            condition
            maintenanceCostValue
            currentBookValue
            installDate
            decommissionDate
            locationId
            image
            purchaseOrderId
            utilizationData
            reasonForDecommission
            serialNumber
            thirdPartyId
            source
            totalCostOfOwnershipValue
            repairCostValue
            warrantyExpiration
            downTime
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            woCount
            findingsCount
            assetRisk
            isParent
            thirdPartyParentId
            thirdPartyHierarchyPath
            __typename
          }
          assignmentGroupId
          assignedToId
          assignedTo {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          businessDownTime
          downTimeStart
          downTimeEnd
          category
          checklist
          closedNotes
          closedAt
          closedById
          closedBy {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          notes
          title
          description
          estimatedCostValue
          actualCostValue
          estimatedEffort
          actualEffort
          expectedOperationalDate
          impact
          priority
          dependsOnWorkOrderId
          dependsOnWorkOrder {
            id
            displayNumber
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            number
            userId
            locationId
            dueDate
            startDate
            endDate
            duration
            plannedStartDate
            plannedEndDate
            assetId
            assignmentGroupId
            assignedToId
            businessDownTime
            downTimeStart
            downTimeEnd
            category
            checklist
            closedNotes
            closedAt
            closedById
            notes
            title
            description
            estimatedCostValue
            actualCostValue
            estimatedEffort
            actualEffort
            expectedOperationalDate
            impact
            priority
            dependsOnWorkOrderId
            state
            type
            templateId
            isArchived
            findingId
            seenByAssignee
            assignmentDateTime
            seenDateTime
            startOfWorkDateTime
            endOfWorkDateTime
            __typename
          }
          state
          type
          templateId
          isArchived
          findingId
          seenByAssignee
          assignmentDateTime
          seenDateTime
          startOfWorkDateTime
          endOfWorkDateTime
          assetModel {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          __typename
        }
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      state
      type
      templateId
      isArchived
      findingId
      seenByAssignee
      assignmentDateTime
      seenDateTime
      startOfWorkDateTime
      endOfWorkDateTime
      assetModel {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkOrderListQueryVariables,
  APITypes.GetWorkOrderListQuery
>;
export const getWorkOrderPropsCounts = /* GraphQL */ `query GetWorkOrderPropsCounts($userId: String) {
  getWorkOrderPropsCounts(userId: $userId) {
    data {
      workOrders
      templates
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkOrderPropsCountsQueryVariables,
  APITypes.GetWorkOrderPropsCountsQuery
>;
export const getWorkOrderRelatedCounts = /* GraphQL */ `query GetWorkOrderRelatedCounts($workOrderId: String!) {
  getWorkOrderRelatedCounts(workOrderId: $workOrderId) {
    data {
      expenses
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkOrderRelatedCountsQueryVariables,
  APITypes.GetWorkOrderRelatedCountsQuery
>;
export const getWorkOrderTemplate = /* GraphQL */ `query GetWorkOrderTemplate($id: String!) {
  getWorkOrderTemplate(id: $id) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      title
      type
      category
      description
      userId
      locationId
      assignmentGroupId
      notes
      estimatedCostValue
      estimatedEffort
      impact
      priority
      executionInterval
      assetManufacturerId
      assetModelId
      assetTypeId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkOrderTemplateQueryVariables,
  APITypes.GetWorkOrderTemplateQuery
>;
export const getWorkOrderTemplateList = /* GraphQL */ `query GetWorkOrderTemplateList($params: QueryListParams) {
  getWorkOrderTemplateList(params: $params) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      title
      type
      category
      description
      userId
      locationId
      assignmentGroupId
      notes
      estimatedCostValue
      estimatedEffort
      impact
      priority
      executionInterval
      assetManufacturerId
      assetModelId
      assetTypeId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWorkOrderTemplateListQueryVariables,
  APITypes.GetWorkOrderTemplateListQuery
>;
export const getManufacturer = /* GraphQL */ `query GetManufacturer($id: String!) {
  getManufacturer(id: $id) {
    data {
      id
      name
      description
      countryId
      website
      contactPerson
      contactEmail
      contactPhone
      address
      warrantyPolicies
      slaDetails
      vendorPortalLink
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      inUseStatus
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetManufacturerQueryVariables,
  APITypes.GetManufacturerQuery
>;
export const getManufacturerList = /* GraphQL */ `query GetManufacturerList($params: QueryListParams) {
  getManufacturerList(params: $params) {
    data {
      id
      name
      description
      countryId
      website
      contactPerson
      contactEmail
      contactPhone
      address
      warrantyPolicies
      slaDetails
      vendorPortalLink
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      inUseStatus
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetManufacturerListQueryVariables,
  APITypes.GetManufacturerListQuery
>;
export const getModel = /* GraphQL */ `query GetModel($id: String!) {
  getModel(id: $id) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      oemPartNumber
      name
      manufacturerId
      assetTypeId
      probability
      severity
      riskScore
      picture
      specification
      usefulLife
      inUseStatus
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<APITypes.GetModelQueryVariables, APITypes.GetModelQuery>;
export const getModelList = /* GraphQL */ `query GetModelList($params: QueryListParams) {
  getModelList(params: $params) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      oemPartNumber
      name
      manufacturerId
      assetTypeId
      probability
      severity
      riskScore
      picture
      specification
      usefulLife
      inUseStatus
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetModelListQueryVariables,
  APITypes.GetModelListQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: String!) {
  getUser(id: $id) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      groups
      email
      name
      phone
      role
      address
      location
      tenants
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const getUserList = /* GraphQL */ `query GetUserList($params: UserQueryListParams) {
  getUserList(params: $params) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      groups
      email
      name
      phone
      role
      address
      location
      tenants
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserListQueryVariables,
  APITypes.GetUserListQuery
>;
export const getTenant = /* GraphQL */ `query GetTenant($id: String!) {
  getTenant(id: $id) {
    data {
      id
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      address
      contacts
      isActive
      cognitoGroupName
      tisId
      plan
      tisSyncedAt
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTenantQueryVariables, APITypes.GetTenantQuery>;
export const getTenantList = /* GraphQL */ `query GetTenantList($params: QueryListParams) {
  getTenantList(params: $params) {
    data {
      id
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      address
      contacts
      isActive
      cognitoGroupName
      tisId
      plan
      tisSyncedAt
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTenantListQueryVariables,
  APITypes.GetTenantListQuery
>;
export const getLocation = /* GraphQL */ `query GetLocation($id: String!) {
  getLocation(id: $id) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      notes
      lat
      lng
      level
      parentId
      rootId
      thirdPartyId
      source
      inUseStatus
      address
      buildingAddress
      parent {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      tisSyncedAt
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLocationQueryVariables,
  APITypes.GetLocationQuery
>;
export const getLocationList = /* GraphQL */ `query GetLocationList($params: QueryListParams) {
  getLocationList(params: $params) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      notes
      lat
      lng
      level
      parentId
      rootId
      thirdPartyId
      source
      inUseStatus
      address
      buildingAddress
      parent {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      tisSyncedAt
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLocationListQueryVariables,
  APITypes.GetLocationListQuery
>;
export const getBuildingList = /* GraphQL */ `query GetBuildingList($params: QueryListParams) {
  getBuildingList(params: $params) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      notes
      lat
      lng
      level
      parentId
      rootId
      thirdPartyId
      source
      inUseStatus
      address
      buildingAddress
      parent {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      tisSyncedAt
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBuildingListQueryVariables,
  APITypes.GetBuildingListQuery
>;
export const getExpense = /* GraphQL */ `query GetExpense($id: String!) {
  getExpense(id: $id) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      title
      description
      type
      status
      number
      amount
      purchaseOrderId
      workOrderId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        dependsOnWorkOrder {
          id
          displayNumber
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          number
          userId
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          locationId
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          assetLocation {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          dueDate
          startDate
          endDate
          duration
          plannedStartDate
          plannedEndDate
          assetId
          asset {
            id
            number
            displayNumber
            userId
            assetTag
            description
            makeId
            modelId
            state
            usefulLife
            acquisitionCostValue
            lastMaintenanceDate
            nextScheduledMaintenanceDate
            assignedToId
            assetTypeId
            condition
            maintenanceCostValue
            currentBookValue
            installDate
            decommissionDate
            locationId
            image
            purchaseOrderId
            utilizationData
            reasonForDecommission
            serialNumber
            thirdPartyId
            source
            totalCostOfOwnershipValue
            repairCostValue
            warrantyExpiration
            downTime
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            woCount
            findingsCount
            assetRisk
            isParent
            thirdPartyParentId
            thirdPartyHierarchyPath
            __typename
          }
          assignmentGroupId
          assignedToId
          assignedTo {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          businessDownTime
          downTimeStart
          downTimeEnd
          category
          checklist
          closedNotes
          closedAt
          closedById
          closedBy {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          notes
          title
          description
          estimatedCostValue
          actualCostValue
          estimatedEffort
          actualEffort
          expectedOperationalDate
          impact
          priority
          dependsOnWorkOrderId
          dependsOnWorkOrder {
            id
            displayNumber
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            number
            userId
            locationId
            dueDate
            startDate
            endDate
            duration
            plannedStartDate
            plannedEndDate
            assetId
            assignmentGroupId
            assignedToId
            businessDownTime
            downTimeStart
            downTimeEnd
            category
            checklist
            closedNotes
            closedAt
            closedById
            notes
            title
            description
            estimatedCostValue
            actualCostValue
            estimatedEffort
            actualEffort
            expectedOperationalDate
            impact
            priority
            dependsOnWorkOrderId
            state
            type
            templateId
            isArchived
            findingId
            seenByAssignee
            assignmentDateTime
            seenDateTime
            startOfWorkDateTime
            endOfWorkDateTime
            __typename
          }
          state
          type
          templateId
          isArchived
          findingId
          seenByAssignee
          assignmentDateTime
          seenDateTime
          startOfWorkDateTime
          endOfWorkDateTime
          assetModel {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          __typename
        }
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExpenseQueryVariables,
  APITypes.GetExpenseQuery
>;
export const getExpenseList = /* GraphQL */ `query GetExpenseList($params: QueryListParams) {
  getExpenseList(params: $params) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      title
      description
      type
      status
      number
      amount
      purchaseOrderId
      workOrderId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        dependsOnWorkOrder {
          id
          displayNumber
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          number
          userId
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          locationId
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          assetLocation {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          dueDate
          startDate
          endDate
          duration
          plannedStartDate
          plannedEndDate
          assetId
          asset {
            id
            number
            displayNumber
            userId
            assetTag
            description
            makeId
            modelId
            state
            usefulLife
            acquisitionCostValue
            lastMaintenanceDate
            nextScheduledMaintenanceDate
            assignedToId
            assetTypeId
            condition
            maintenanceCostValue
            currentBookValue
            installDate
            decommissionDate
            locationId
            image
            purchaseOrderId
            utilizationData
            reasonForDecommission
            serialNumber
            thirdPartyId
            source
            totalCostOfOwnershipValue
            repairCostValue
            warrantyExpiration
            downTime
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            woCount
            findingsCount
            assetRisk
            isParent
            thirdPartyParentId
            thirdPartyHierarchyPath
            __typename
          }
          assignmentGroupId
          assignedToId
          assignedTo {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          businessDownTime
          downTimeStart
          downTimeEnd
          category
          checklist
          closedNotes
          closedAt
          closedById
          closedBy {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          notes
          title
          description
          estimatedCostValue
          actualCostValue
          estimatedEffort
          actualEffort
          expectedOperationalDate
          impact
          priority
          dependsOnWorkOrderId
          dependsOnWorkOrder {
            id
            displayNumber
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            number
            userId
            locationId
            dueDate
            startDate
            endDate
            duration
            plannedStartDate
            plannedEndDate
            assetId
            assignmentGroupId
            assignedToId
            businessDownTime
            downTimeStart
            downTimeEnd
            category
            checklist
            closedNotes
            closedAt
            closedById
            notes
            title
            description
            estimatedCostValue
            actualCostValue
            estimatedEffort
            actualEffort
            expectedOperationalDate
            impact
            priority
            dependsOnWorkOrderId
            state
            type
            templateId
            isArchived
            findingId
            seenByAssignee
            assignmentDateTime
            seenDateTime
            startOfWorkDateTime
            endOfWorkDateTime
            __typename
          }
          state
          type
          templateId
          isArchived
          findingId
          seenByAssignee
          assignmentDateTime
          seenDateTime
          startOfWorkDateTime
          endOfWorkDateTime
          assetModel {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          __typename
        }
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExpenseListQueryVariables,
  APITypes.GetExpenseListQuery
>;
export const getAssetType = /* GraphQL */ `query GetAssetType($id: String!) {
  getAssetType(id: $id) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      name
      description
      category
      criticalityLevel
      expectedUsefulLife
      defaultWarrantyPeriod
      defaultRiskScore
      manufacturerRecommendations
      image
      thirdPartyId
      thirdPartySource
      inUseStatus
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssetTypeQueryVariables,
  APITypes.GetAssetTypeQuery
>;
export const getAssetTypeList = /* GraphQL */ `query GetAssetTypeList($params: QueryListParams) {
  getAssetTypeList(params: $params) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      name
      description
      category
      criticalityLevel
      expectedUsefulLife
      defaultWarrantyPeriod
      defaultRiskScore
      manufacturerRecommendations
      image
      thirdPartyId
      thirdPartySource
      inUseStatus
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssetTypeListQueryVariables,
  APITypes.GetAssetTypeListQuery
>;
export const getFinding = /* GraphQL */ `query GetFinding($id: String!) {
  getFinding(id: $id) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      number
      displayNumber
      shortDescription
      priority
      estimatedRepairCost
      plannedRepairDate
      description
      cause
      symptom
      picture
      reportedOn
      workOrderId
      type
      reportedById
      status
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      locationId
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      isArchived
      thirdPartyId
      thirdPartySource
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFindingQueryVariables,
  APITypes.GetFindingQuery
>;
export const getFindingList = /* GraphQL */ `query GetFindingList($params: QueryListParams) {
  getFindingList(params: $params) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      number
      displayNumber
      shortDescription
      priority
      estimatedRepairCost
      plannedRepairDate
      description
      cause
      symptom
      picture
      reportedOn
      workOrderId
      type
      reportedById
      status
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      locationId
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      isArchived
      thirdPartyId
      thirdPartySource
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFindingListQueryVariables,
  APITypes.GetFindingListQuery
>;
export const getAttachment = /* GraphQL */ `query GetAttachment($id: String!) {
  getAttachment(id: $id) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      fileName
      originalFileName
      path
      downloadUrl
      mimeType
      size
      description
      relatedTable
      relatedItem
      type
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAttachmentQueryVariables,
  APITypes.GetAttachmentQuery
>;
export const getAttachmentList = /* GraphQL */ `query GetAttachmentList($params: QueryListParams) {
  getAttachmentList(params: $params) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      fileName
      originalFileName
      path
      downloadUrl
      mimeType
      size
      description
      relatedTable
      relatedItem
      type
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAttachmentListQueryVariables,
  APITypes.GetAttachmentListQuery
>;
export const getAlert = /* GraphQL */ `query GetAlert($id: String!) {
  getAlert(id: $id) {
    data {
      id
      number
      displayNumber
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assetId
      daysFailed
      tisStatus
      state
      firstException
      worstException
      lastException
      impactComfort
      impactEnergy
      impactReliability
      testValue
      exceptionName
      suggestionDescription
      suggestionCauses
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        dependsOnWorkOrder {
          id
          displayNumber
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          number
          userId
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          locationId
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          assetLocation {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          dueDate
          startDate
          endDate
          duration
          plannedStartDate
          plannedEndDate
          assetId
          asset {
            id
            number
            displayNumber
            userId
            assetTag
            description
            makeId
            modelId
            state
            usefulLife
            acquisitionCostValue
            lastMaintenanceDate
            nextScheduledMaintenanceDate
            assignedToId
            assetTypeId
            condition
            maintenanceCostValue
            currentBookValue
            installDate
            decommissionDate
            locationId
            image
            purchaseOrderId
            utilizationData
            reasonForDecommission
            serialNumber
            thirdPartyId
            source
            totalCostOfOwnershipValue
            repairCostValue
            warrantyExpiration
            downTime
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            woCount
            findingsCount
            assetRisk
            isParent
            thirdPartyParentId
            thirdPartyHierarchyPath
            __typename
          }
          assignmentGroupId
          assignedToId
          assignedTo {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          businessDownTime
          downTimeStart
          downTimeEnd
          category
          checklist
          closedNotes
          closedAt
          closedById
          closedBy {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          notes
          title
          description
          estimatedCostValue
          actualCostValue
          estimatedEffort
          actualEffort
          expectedOperationalDate
          impact
          priority
          dependsOnWorkOrderId
          dependsOnWorkOrder {
            id
            displayNumber
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            number
            userId
            locationId
            dueDate
            startDate
            endDate
            duration
            plannedStartDate
            plannedEndDate
            assetId
            assignmentGroupId
            assignedToId
            businessDownTime
            downTimeStart
            downTimeEnd
            category
            checklist
            closedNotes
            closedAt
            closedById
            notes
            title
            description
            estimatedCostValue
            actualCostValue
            estimatedEffort
            actualEffort
            expectedOperationalDate
            impact
            priority
            dependsOnWorkOrderId
            state
            type
            templateId
            isArchived
            findingId
            seenByAssignee
            assignmentDateTime
            seenDateTime
            startOfWorkDateTime
            endOfWorkDateTime
            __typename
          }
          state
          type
          templateId
          isArchived
          findingId
          seenByAssignee
          assignmentDateTime
          seenDateTime
          startOfWorkDateTime
          endOfWorkDateTime
          assetModel {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          __typename
        }
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      workOrderId
      finding {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        number
        displayNumber
        shortDescription
        priority
        estimatedRepairCost
        plannedRepairDate
        description
        cause
        symptom
        picture
        reportedOn
        workOrderId
        type
        reportedById
        status
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        locationId
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        isArchived
        thirdPartyId
        thirdPartySource
        __typename
      }
      findingId
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedQuery<APITypes.GetAlertQueryVariables, APITypes.GetAlertQuery>;
export const getAlertList = /* GraphQL */ `query GetAlertList($params: QueryListParams) {
  getAlertList(params: $params) {
    data {
      id
      number
      displayNumber
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assetId
      daysFailed
      tisStatus
      state
      firstException
      worstException
      lastException
      impactComfort
      impactEnergy
      impactReliability
      testValue
      exceptionName
      suggestionDescription
      suggestionCauses
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        dependsOnWorkOrder {
          id
          displayNumber
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          number
          userId
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          locationId
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          assetLocation {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          dueDate
          startDate
          endDate
          duration
          plannedStartDate
          plannedEndDate
          assetId
          asset {
            id
            number
            displayNumber
            userId
            assetTag
            description
            makeId
            modelId
            state
            usefulLife
            acquisitionCostValue
            lastMaintenanceDate
            nextScheduledMaintenanceDate
            assignedToId
            assetTypeId
            condition
            maintenanceCostValue
            currentBookValue
            installDate
            decommissionDate
            locationId
            image
            purchaseOrderId
            utilizationData
            reasonForDecommission
            serialNumber
            thirdPartyId
            source
            totalCostOfOwnershipValue
            repairCostValue
            warrantyExpiration
            downTime
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            woCount
            findingsCount
            assetRisk
            isParent
            thirdPartyParentId
            thirdPartyHierarchyPath
            __typename
          }
          assignmentGroupId
          assignedToId
          assignedTo {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          businessDownTime
          downTimeStart
          downTimeEnd
          category
          checklist
          closedNotes
          closedAt
          closedById
          closedBy {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          notes
          title
          description
          estimatedCostValue
          actualCostValue
          estimatedEffort
          actualEffort
          expectedOperationalDate
          impact
          priority
          dependsOnWorkOrderId
          dependsOnWorkOrder {
            id
            displayNumber
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            number
            userId
            locationId
            dueDate
            startDate
            endDate
            duration
            plannedStartDate
            plannedEndDate
            assetId
            assignmentGroupId
            assignedToId
            businessDownTime
            downTimeStart
            downTimeEnd
            category
            checklist
            closedNotes
            closedAt
            closedById
            notes
            title
            description
            estimatedCostValue
            actualCostValue
            estimatedEffort
            actualEffort
            expectedOperationalDate
            impact
            priority
            dependsOnWorkOrderId
            state
            type
            templateId
            isArchived
            findingId
            seenByAssignee
            assignmentDateTime
            seenDateTime
            startOfWorkDateTime
            endOfWorkDateTime
            __typename
          }
          state
          type
          templateId
          isArchived
          findingId
          seenByAssignee
          assignmentDateTime
          seenDateTime
          startOfWorkDateTime
          endOfWorkDateTime
          assetModel {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          __typename
        }
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      workOrderId
      finding {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        number
        displayNumber
        shortDescription
        priority
        estimatedRepairCost
        plannedRepairDate
        description
        cause
        symptom
        picture
        reportedOn
        workOrderId
        type
        reportedById
        status
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        locationId
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        isArchived
        thirdPartyId
        thirdPartySource
        __typename
      }
      findingId
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        __typename
      }
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAlertListQueryVariables,
  APITypes.GetAlertListQuery
>;
